import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  TextField,
  Stepper,
  Step,
  StepLabel,
  Dialog,
} from "@mui/material";
import DashboardHeader from "../Dashboard/DashboardHeader";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseapi } from "../Environmentalurl";
import {
  ApplicationType,
  date,
  entity_id,
  getGeolocation,
  location,
  locationGeo,
  Platform,
} from "../Utils/Const";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

const QUESTIONS = [
  "What is your favorite book?",
  "What is your favorite food?",
  "What city were you born in?",
  "What is your favorite color?",
  "What is your mother's maiden name?",
  "Where did you go to high school/college?",
  "Where is your favorite place to vacation?",
  "What was the first company that you worked for?",
  "Who is your favorite actor, musician, or artist?",
  "What was the name of your favorite pet?",
  "What were the last four digits of your mobile number?",
];

export default function Rupayonboarding() {
  const [apiMessage, setApiMessage] = useState("");
  const [openMessage, setOpenMessage] = useState(false);

  const [step, setStep] = useState(0); // 0 = T&C, 1 = Security Questions
  const [agree, setAgree] = useState(false);

  const [activeQuestion, setActiveQuestion] = useState(0);

  const [securityQuestions, setSecurityQuestions] = useState([
    { question: "", answer: "" },
    { question: "", answer: "" },
    { question: "", answer: "" },
  ]);

  const handleChange = (field, value) => {
    const updated = [...securityQuestions];
    updated[activeQuestion][field] = value;
    setSecurityQuestions(updated);
  };

  const handleNext = () => {
    if (activeQuestion < 2) {
      setActiveQuestion((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (activeQuestion > 0) {
      setActiveQuestion((prev) => prev - 1);
    } else {
      setStep(0);
    }
  };
 const ip = useIPAddress();
  const current = securityQuestions[activeQuestion];

  const navigate = useNavigate();
  const accountNo = useSelector((state) => state.auth.accountNo);
  useEffect(() => {
    console.log("Redux AccountNo:", accountNo);
  }, [accountNo]);

  const handleSubmit = async () => {
    try {
      // 📦 SESSION VALUES
      const mobileNumber = JSON.parse(sessionStorage.getItem("mobileNumber"));
      const sessionId = JSON.parse(sessionStorage.getItem("SessionID"));
      const email = JSON.parse(sessionStorage.getItem("Poiemail"))
        ?.replace(/^"+|"+$/g, "")
        ?.trim();

      const nameOnCard = JSON.parse(sessionStorage.getItem("NameOnCard"));
      const virtualaccount_num = JSON.parse(
        sessionStorage.getItem("virtualAccountNo"),
      );


      const payload = {
        ReqType: "Jan_Aadhaar_eWallet_RuPayCardGenerationRequest",
        ReqTypeID: "1",
        RequestedBy: mobileNumber,
        Mobilenumber: mobileNumber,
        SessionID: sessionId,
        Email: email,
        CustomerName: nameOnCard,
        NameonCard: nameOnCard,
        SecurityQuestion: securityQuestions[0].question,
        SecurityAnswer: securityQuestions[0].answer,
        SecurityQuestion2: securityQuestions[1].question,
        SecurityAnswer2: securityQuestions[1].answer,
        SecurityQuestion3: securityQuestions[2].question,
        SecurityAnswer3: securityQuestions[2].answer,
        ReferenceNumber: "",
        OldReferenceNumber: "",
        CardNumber: "",
        CardStatus: "",
        OTP: "",
        IsMobileVerified: "1",
        IsEmailVerified: "1",
        Statement: "RupayCardRequest",
        Virtual_Account: virtualaccount_num,
        Platform: Platform,
        ApplicationType: ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
        Date: date,
      };

      const res = await api.post(
        `${baseapi}/ruPayCardGenerationRequest`,
        payload,
      );

      // ✅ SUCCESS HANDLING
      if (res.data?.Response_Code === "1000") {
        setApiMessage(res.data.Message || "RuPay Card generated successfully");
        setOpenMessage(true);

        setTimeout(() => {
          navigate("/dashboard/rupaycard");
        }, 2000);
      } else {
        setApiMessage(res.data.Message || "Something went wrong");
        setOpenMessage(true);
      }
    } catch (error) {
      console.error(error);
      setApiMessage("Server error. Please try again.");
      setOpenMessage(true);
    }
  };

  return (
    <>
      <DashboardHeader />

      <Box
        sx={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          bgcolor: "#f3f4f6",
        }}
      >
        <Card sx={{ width: "100%", maxWidth: 480, p: 4, borderRadius: 3 }}>
          {/* STEP 1 – TERMS */}
          {step === 0 && (
            <>
              <Typography variant="h6" fontWeight={600} textAlign="center">
                Virtual RuPay Card Request
              </Typography>

              <Typography mt={2} fontSize={14} color="text.secondary">
                TA Wallet Virtual RuPay Card can be used at all online
                e-commerce merchants where RuPay is accepted.
              </Typography>

              <FormControlLabel
                sx={{ mt: 3 }}
                control={
                  <Checkbox
                    checked={agree}
                    onChange={(e) => setAgree(e.target.checked)}
                  />
                }
                label="I agree to the Terms and Conditions"
              />

              <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3 }}
                disabled={!agree}
                onClick={() => setStep(1)}
              >
                Proceed
              </Button>
            </>
          )}

          {/* STEP 2 – SECURITY QUESTIONS (ONE BY ONE) */}
          {step === 1 && (
            <>
              <Typography variant="h6" fontWeight={600} textAlign="center">
                Set Security Question
              </Typography>

              <Stepper
                activeStep={activeQuestion}
                alternativeLabel
                sx={{ mt: 3 }}
              >
                <Step>
                  <StepLabel>Question1</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Question2</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Question3</StepLabel>
                </Step>
              </Stepper>

              <Typography
                mt={2}
                fontSize={13}
                color="text.secondary"
                textAlign="center"
              >
                Choose a security question and enter your answer
              </Typography>

              {/* SINGLE QUESTION */}
              <Box mt={4}>
                <Select
                  fullWidth
                  displayEmpty
                  value={current.question}
                  onChange={(e) => handleChange("question", e.target.value)}
                >
                  <MenuItem value="">Choose Security Question</MenuItem>
                  {QUESTIONS.map((q, i) => (
                    <MenuItem key={i} value={q}>
                      {q}
                    </MenuItem>
                  ))}
                </Select>

                <TextField
                  fullWidth
                  placeholder="Enter Answer"
                  sx={{ mt: 2 }}
                  value={current.answer}
                  onChange={(e) => handleChange("answer", e.target.value)}
                />
              </Box>

              <Box display="flex" gap={2} mt={4}>
                <Button fullWidth variant="outlined" onClick={handleBack}>
                  Back
                </Button>

                {activeQuestion < 2 ? (
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={handleNext}
                    disabled={!current.question || !current.answer}
                  >
                    Next
                  </Button>
                ) : (
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={!current.question || !current.answer}
                  >
                    Submit
                  </Button>
                )}
              </Box>
            </>
          )}
        </Card>
      </Box>
      <Dialog open={openMessage} onClose={() => setOpenMessage(false)}>
        <Box p={3} textAlign="center" width={300}>
          <Typography fontWeight={600}>{apiMessage}</Typography>

          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => setOpenMessage(false)}
          >
            OK
          </Button>
        </Box>
      </Dialog>
    </>
  );
}
